import { withErrorBoundary } from 'react-error-boundary';
import styled from 'styled-components';
import { breakpoint } from 'variables';
import type { SectionNavigationType } from '../../shared/types';
import SectionNavigation from './SectionNavigation';
import SectionNavigationDrawer from './SectionNavigationDrawer';

const ShowOnMobile = styled.div`
    ${breakpoint.up('1025px')} {
        display: none;
    }
`;

const ShowOnDesktop = styled.div`
    display: none;

    ${breakpoint.up('1025px')} {
        display: block;
    }
`;

function SectionNavigationRenderer({ sections, currentSectionId, frontPageUrl }: SectionNavigationType) {
    return (
        <>
            <ShowOnDesktop>
                <SectionNavigation
                    sections={sections}
                    frontPageUrl={frontPageUrl}
                    currentSectionId={currentSectionId}
                />
            </ShowOnDesktop>
            <ShowOnMobile>
                <SectionNavigationDrawer
                    sections={sections}
                    frontPageUrl={frontPageUrl}
                    currentSectionId={currentSectionId}
                />
            </ShowOnMobile>
        </>
    );
}

export default withErrorBoundary(SectionNavigationRenderer, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
